module.exports = __webpack_public_path__ + "41563204.svg";